import { connect } from 'react-redux';
import NestedAccessoriesModal from './NestedAccessoriesModal';
import { getAccessories, getTreeStructureSettings } from '../../../../../store/form/selectors';
import { getModals } from '../../../../../store/modals/selectors';
import { setOpenModal } from '../../../../../store/modals/actions';
import { setTreeStructureSettings } from '../../../../../store/form/actions';

const mapStateToProps = (state) => ({
  accessories: getAccessories(state),
  treeStructureSettings: getTreeStructureSettings(state),
  modals: getModals(state),
});

const mapDispatchToProps = (dispatch) => ({
  setOpenModal: (modal, value) => dispatch(setOpenModal(modal, value)),
  setTreeStructureSettings: (level, parentId, parentName) => dispatch(
    setTreeStructureSettings(level, parentId, parentName),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(NestedAccessoriesModal);
